module.exports = __webpack_public_path__ + "img/settings.d35a9b88.svg";